import React from 'react';
import icLink from '../assets/ic_link.png';
import icIntegrate from '../assets/ic_integrate.png';
import icDeliv from '../assets/ic_deliv.png';

const HowItWorks = () => {
  return (
    <section id="comment-ca-marche" className="py-16 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2 animate-on-scroll">
          Comment ça marche ?
        </h2>
        <p className="section-description animate-on-scroll">
          De l'expédition à la livraison, en toute simplicité
        </p>
        <div className="flex flex-col md:flex-row justify-center gap-4 animate-on-scroll">
          {/* Card 1 */}
          <div className="service-card flex-1 p-8 bg-[#F7F8F9] rounded-xl animate-on-scroll">
            <div className="text-left">
              <div className="service-icon text-6xl font-bold text-gray-600 mt-6">1</div>
              <h3 className="text-2xl font-semibold mb-2 text-gray-800 mt-12">
              Commandez en ligne
              </h3>
              <p className="text-gray-500 font-inter font-inter mb-5">
              Indiquez le point de départ et d'arrivée, sans créer de compte, ou directement depuis votre boutique connectée.
              </p>
            </div>
          </div>
          {/* Card 2 */}
          <div className="service-card flex-1 p-8 bg-[#F7F8F9] rounded-xl animate-on-scroll">
            <div className="text-left">
              <div className="service-icon text-6xl font-bold text-gray-600 mt-6">2</div>
              <h3 className="text-2xl font-semibold mb-2 text-gray-800 mt-12">
                On récupère votre colis
              </h3>
              <p className="text-gray-500 font-inter mb-5">
                Un livreur OuiGoo passe le prendre à l'adresse de départ, au moment convenu.
              </p>
            </div>
          </div>
          {/* Card 3 */}
          <div className="service-card flex-1 p-8 bg-[#F7F8F9] rounded-xl animate-on-scroll">
            <div className="text-left">
              <div className="service-icon text-6xl font-bold text-gray-600 mt-6">3</div>
              <h3 className="text-2xl font-semibold mb-2 text-gray-800 mt-12">
                On livre, vous suivez
              </h3>
              <p className="text-gray-500 font-inter mb-5">
                Livraison rapide au destinataire, avec un suivi en temps réel jusqu'à l'arrivée.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
